<template>
  <div class="evaluation-viewer-question">
    <h2><span class="index">{{ index.join('.') }}</span>{{ question.name }}</h2>
    <main>
      <evaluation-answer
        :question="question"
        :branch-type="branchType"
        :disabled="true"
      />
      <evaluation-viewer-comment
        :comment="question.comment"
      />
      <evaluation-viewer-evidence
        :evidence="question.evidence"
      />
    </main>
  </div>
</template>

<script>
import EvaluationViewerAnswer from '@/modules/evaluation-viewer/components/evaluation-viewer-answer'
import EvaluationViewerComment from '@/modules/evaluation-viewer/components/evaluation-viewer-comment'
import EvaluationViewerEvidence from '@/modules/evaluation-viewer/components/evaluation-viewer-evidence'
import EvaluationAnswer from '@/modules/evaluation/components/layout/evaluation-answer'
/**
   * 'EvaluationViewerQuestion' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'EvaluationViewerQuestion',
  components: {EvaluationAnswer, EvaluationViewerEvidence, EvaluationViewerComment, EvaluationViewerAnswer},
  inject: ['branchType'],
  props: {
    question: {
      type: Object,
      required: true
    },
    index: {
      type: Array,
      required: true
    }
  },
  methods: {
    getResult (value) {
      switch (this.question.type) {
        case 'multiple':

          break
        default:
          return value
      }
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
    .evaluation-viewer-question {
      border-bottom: 1px solid #cdcdcd;
      padding: 50px 30px;
      h2{
        @include font-primary(16px, regular);
        display: block;
        span.index{
          display: inline-block;
          border:1px solid $color-ui-primary;
          color: $color-ui-primary;
          padding: 3px;
          min-width: 18px;
          text-align: center;
          border-radius: 2px;
          margin-right: 20px;
        }
      }
      main{
        padding: 20px 70px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/modules/evaluation-viewer/components/evaluation-viewer-question.vue